import {
    getInvoiceItem,
    listInvoiceItems
} from './queries';
import {
    createInvoiceItem,
    deleteInvoiceItem,
    updateInvoiceItem,
} from './mutations';

import {GraphQLQuery,} from '@aws-amplify/api';
import {InvoiceItem} from "../types.ts";
import {generateClient} from "aws-amplify/api";


export type ListInvoiceItems = {
    listInvoiceItems: { items: InvoiceItem[], nextToken?: string }
}

export type GetInvoiceItem = {
    getInvoiceItem: InvoiceItem
}

export type CreateInvoiceItem = {
    createInvoiceItem: InvoiceItem
}

export type UpdateInvoiceItem = {
    updateInvoiceItem: InvoiceItem
}

export type DeleteInvoiceItem = {
    deleteInvoiceItem: string
}

const client = generateClient();

export const fetchRecords = async (filter: object, limit?: number, nextToken?: string) => {

    const response = await client.graphql<GraphQLQuery<ListInvoiceItems>>({
                                                                              query: listInvoiceItems,
                                                                              variables: {filter: filter, limit, nextToken},
                                                                          });
    return response.data?.listInvoiceItems;
};

export const fetch = async (invoiceId: string, id: string) => {
    const response = await client.graphql<GraphQLQuery<GetInvoiceItem>>({
                                                                            query: getInvoiceItem,
                                                                            variables: {
                                                                                invoice: invoiceId,
                                                                                id: id
                                                                            },
                                                                        });
    return response.data?.getInvoiceItem;
};

export const add = async (payload: object) => {

    const response = await client.graphql<GraphQLQuery<CreateInvoiceItem>>({
                                                                               query: createInvoiceItem,
                                                                               variables: {input: payload},
                                                                           });

    return response.data?.createInvoiceItem;
};

export const update = async (record: InvoiceItem) => {

    delete record.created;
    delete record.updated;

    const response = await client.graphql<GraphQLQuery<UpdateInvoiceItem>>({
                                                                               query: (updateInvoiceItem),
                                                                               variables: {input: record},
                                                                           });
    return response.data?.updateInvoiceItem;
};

export const deleteRecord = async (_invoiceId: string, id: string) => {
    const response = await client.graphql<GraphQLQuery<DeleteInvoiceItem>>({
                                                                               query: (deleteInvoiceItem),
                                                                               variables: {
                                                                                   input: {
                                                                                       id: id
                                                                                   }
                                                                               },

                                                                           });
    return response.data?.deleteInvoiceItem;
};
